<template>
  <div>
    <div class="tabBox">
      <div class="yearClose">
        <!--<img src="@/assets/img/loginImg/tabClose.png" alt="" />
         <p>跳过</p> -->
      </div>
      <p class="title1">请选择感兴趣的课程</p>
      <p class="text1">为您推荐更多课程（可随时更改，请放心选择）</p>
      <ul class="yearList">
        <li
          v-for="(item, index) in newData"
          :key="index"
          :class="{ active: index == yearInd }"
          @click="optYear(index)"
        >
          <img
            :src="item.imgUrl||defaultIcon"
            alt=""
          />
          <div :class="{box:findRes(item)}">
            <p>{{ item.value }}</p>
            <span class="mark">{{ findRes(item) }}</span>
          </div>
        </li>
      </ul>
      <div
        class="confirmBtn"
        @click="confirmBtn"
      >选好了</div>
    </div>
    <!-- <div class="cover" v-if="showTop" @click="closeTip">
      <img class="tip1" src="@/assets/img/components/home/tip1.png" alt="" srcset="" />
      <img class="tip2" src="@/assets/img/components/home/tip2.png" alt="" srcset="" />
    </div> -->
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { reqChoseRecords, reqTypeList } from '@/api/home';
import iconList from '@/utils/iconsTypes';

export default {
  props: {
    // newData: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      yearInd: -1,
      showTop: false,
      newData: [],
      defaultIcon:'https://iqh-zt-pord-cdn.iqihang.com/23jxPC/icon-22.png',
      markList: [
        {
          code: 2,
          name: '2022年12月考试',
        },
        {
          code: 8,
          name: '2023年12月考试',
        },
        {
          code: 10,
          name: '2024年12月考试',
        },
      ],
    };
  },
  computed: {
    ...mapState(['currentYear']),
  },
  watch: {
    currentYear: {
      handler(v) {
        let yearIndex = -1; // 默认 22考研
        for (let i = 0; i < this.newData.length; i += 1) {
          if (v.value === this.newData[i].value) {
            yearIndex = i;
          }
        }
        console.log(yearIndex, v, 444, this.newData);
        this.yearInd = v ? yearIndex : -1;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions(['setcurrentyear']),
    // 关闭年份选择
    closeYearBox() {
      this.$emit('closeYearBox');
    },
    // 选择tab
    optYear(index) {
      if (index !== this.yearInd) {
        this.yearInd = index;
      } else {
        this.yearInd = -1;
      }
    },
    showCurrent() {
      let yearIndex = 1; // 默认 22考研
      for (let i = 0; i < this.newData.length; i += 1) {
        if (this.currentYear.value === this.newData[i].value) {
          yearIndex = i;
        }
      }
      this.yearInd = yearIndex;
    },
    // 选好了
    async confirmBtn() {
      const { yearInd } = this;
      if (yearInd !== -1) {
        const { code } = this.newData[yearInd];
        reqChoseRecords({
          examTypeId: code,
        });
        // 修改考季
        setTimeout(() => {
          this.setcurrentyear(this.newData[yearInd]);
          this.$emit('closeYearBox');
          if (this.$root.$data.isApp) {
            this.$sendToApp('showAdvertPopupWindow', Number(code));
          }
          // 25 26 下架后，不需要了
          this.jumpNewExamYear(code)
        }, 200);
      } else {
        this.$toast({
          message: '请选择注册类型',
          position: 'middle',
          duration: 2000,
        });
      }
    },
    jumpNewExamYear(code){
      const arr=[3,4,5,9,10,12];
      if(!arr.find((item)=>(item==code))){
        this.$router.push({
          path:'/commonExamYear',
          query:{
            code
          }
        })
      }
    },
    getShow(type) {
      if (Number(type) === 1) {
        this.showTop = true;
      }
    },
    // 初始化 是否展示兴趣引导
    initShowTiP() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('isShowTip');
      } else {
        this.showTop = !window.localStorage.getItem('SHOWTIP');
      }
    },
    // 关闭兴趣引导
    closeTip() {
      if (this.$root.$data.isApp) {
        this.$sendToApp('setShowTip');
      } else {
        window.localStorage.setItem('SHOWTIP', true);
      }
      this.showTop = false;
    },
    async getTypeList() {
      const res = await reqTypeList('HOME_EXAM_CONFIG_H5');
      if (res.code === 0) {
        const navList = res.data;
        navList.map((item) => {
          // eslint-disable-next-line array-callback-return
          iconList.map((e) => {
            if (item.code === e.code) {
              Object.assign(item, e);
              // console.log(item)
            }
          });
          return item;
        });
        this.newData = navList;
        this.showCurrent();
      }
    },
    findRes(data) {
      const res = this.markList.find((item) => item.code === Number(data.code));
      return res?.name;
    },
  },
  created() {
    this.initShowTiP();
    this.getTypeList();
  },
  mounted() {
    window.H5ShowTip = (type) => {
      this.getShow(type);
    };
  },
};
</script>

<style lang="scss" scoped>
.cover {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2020;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.5);
  .tip1 {
    display: block;
    width: 90%;
    margin: 250px auto 100px;
  }
  .tip2 {
    display: block;
    width: 294px;
    height: 118px;
    margin: 0 auto;
  }
}
.tabBox {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2000;
  // display: none;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #fff;
}

.yearClose {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 36px 36px 42px 0;

  p {
    // width: 64px;
    height: 44px;
    margin-left: 9px;
    color: #a5a5a5;
    font-weight: 400;
    font-size: 32px;
    line-height: 44px;
  }

  img {
    width: 28px;
    height: 28px;
  }
}

.title1 {
  // margin-left: 53px;
  color: $fontColor;
  font-size: 48px;
  line-height: 66px;
  text-align: center;
}

.text1 {
  margin-top: 10px;
  // margin-left: 53px;
  color: $fontColor;
  font-size: 28px;
  line-height: 40px;
  text-align: center;
}

.yearList {
  display: flex;
  flex-wrap: wrap;
  // justify-content: space-between;
  // overflow-x: hidden;
  // height: calc(100% - 350px);
  padding: 100px 40px 6px;
  overflow-y: scroll;
  li {
    position: relative;
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: 322px;
    height: 140px;
    margin: 0 20px 32px 0;
    background: #f5f7fb;
    border: 2px solid #f5f7fb;
    border-radius: 16px;

    img {
      width: 140px;
      height: 140px;
    }
    > div.box {
      p {
        padding-bottom: 20px;
      }
    }
    > div {
      position: relative;
      width: 182px;
      // height: 140px;
      // display: flex;
      // align-content: center;
      // align-items: center;
      // flex-wrap: wrap;
      p {
        width: 100%;
        padding: 0 10px 0 0;
        color: $fontColor;
        font-size: 32px;
        line-height: 44px;
        text-align: center;
      }
      .mark {
        position: absolute;
        right: 0;
        bottom: -2px;
        display: inline-block;
        width: 105%;
        color: #666;
        font-weight: 400;
        font-size: 20px;
        text-align: center;
        transform: scale(0.85);
      }
    }
  }
  li:nth-child(2n) {
    margin-right: 0;
  }
  .active {
    border: 2px solid #ff6c02;
  }
  .active::after {
    position: absolute;
    right: -2px;
    bottom: 0;
    display: block;
    width: 44px;
    height: 44px;
    background: url(../../../assets/img/loginImg/tabActive.png) no-repeat;
    background-size: 100% 100%;
    content: '';
  }
}

.confirmBtn {
  position: absolute;
  right: 0;
  bottom: 30px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 702px;
  height: 100px;
  margin: 0 auto;
  color: $bgWhite;
  font-weight: 500;
  font-size: 42px;
  background: #ff6c02;
  border-radius: 16px;
}
</style>
